/**
 * Centralized Store Mapping & URL Utilities
 * Handles the double-hyphen slug structure:
 * /price-tracker/[store-label]-[product-slug]--[sid]--[pid]--[pt1id]
 */

export const storeInfo = {
  1: { label: "Flipkart", domain: "flipkart.com", favIcon: "https://www.google.com/s2/favicons?sz=64&domain=flipkart.com" },
  2: { label: "Amazon", domain: "amazon.in", favIcon: "https://www.google.com/s2/favicons?sz=64&domain=amazon.in" },
  3: { label: "ShopClues", domain: "shopclues.com", favIcon: "https://www.google.com/s2/favicons?sz=64&domain=shopclues.com" },
  4: { label: "Snapdeal", domain: "snapdeal.com", favIcon: "https://www.google.com/s2/favicons?sz=64&domain=snapdeal.com" },
  5: { label: "JioMart", domain: "jiomart.com", favIcon: "https://www.google.com/s2/favicons?sz=64&domain=jiomart.com" },
  6: { label: "Tata CLiQ", domain: "tatacliq.com", favIcon: "https://www.google.com/s2/favicons?sz=64&domain=tatacliq.com" },
  7: { label: "Myntra", domain: "myntra.com", favIcon: "https://www.google.com/s2/favicons?sz=64&domain=myntra.com" },
  8: { label: "Nykaa", domain: "nykaa.com", favIcon: "https://www.google.com/s2/favicons?sz=64&domain=nykaa.com" },
  9: { label: "Ajio", domain: "ajio.com", favIcon: "https://www.google.com/s2/favicons?sz=64&domain=ajio.com" },
  10: { label: "Pepperfry", domain: "pepperfry.com", favIcon: "https://www.google.com/s2/favicons?sz=64&domain=pepperfry.com" },
  11: { label: "FirstCry", domain: "firstcry.com", favIcon: "https://www.google.com/s2/favicons?sz=64&domain=firstcry.com" },
  12: { label: "Nykaa Fashion", domain: "nykaafashion.com", favIcon: "https://www.google.com/s2/favicons?sz=64&domain=nykaafashion.com" },
  13: { label: "Croma", domain: "croma.com", favIcon: "https://www.google.com/s2/favicons?sz=64&domain=croma.com" },
  14: { label: "Reliance Digital", domain: "reliancedigital.in", favIcon: "https://www.google.com/s2/favicons?sz=64&domain=reliancedigital.in" },
  15: { label: "Meesho", domain: "meesho.com", favIcon: "https://www.google.com/s2/favicons?sz=64&domain=meesho.com" },
  16: { label: "Purplle", domain: "purplle.com", favIcon: "https://www.google.com/s2/favicons?sz=64&domain=purplle.com" },
  17: { label: "Shopsy", domain: "shopsy.in", favIcon: "https://www.google.com/s2/favicons?sz=64&domain=shopsy.in" },
};

/**
 * Creates a slugified version of a string
 */
export const slugify = (text) => {
  return text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "-") // Replace spaces with -
    .replace(/[^\w-]+/g, "") // Remove all non-word chars
    .replace(/--+/g, "-"); // Replace multiple - with single -
};

/**
 * Generates a full product URL path
 */
export const createProductUrl = (product) => {
  const { sid, pid, title } = product;
  const storeLabel = storeInfo[sid]?.label.toLowerCase().replace(/\s+/g, "") || "store";
  const productSlug = slugify(title);
  
  // Format: /price-tracker/[store-label]-[product-slug]--[sid]--[pid]
  return `/price-tracker/${storeLabel}-${productSlug}--${sid}--${pid}`;
};

/**
 * Parses a product slug back into its constituent IDs
 */
export const parseProductUrl = (slug) => {
  if (!slug) return null;
  const parts = slug.split("--");
  
  if (parts.length < 3) return null;
  
  return {
    slugPrefix: parts[0],
    sid: parts[1],
    pid: parts[2],
  };
};
